<template>
  <div>
    <div class="imageContainer">
      <div>
        <img class="logo" src="../assets/guide-logo.png" />
        <div class="title">全球领先的技术技能人才产业服务平台</div>
        <div class="desc">
          技能码是在全球范围内备受追棒的技术技能认证和评估系统。它不仅能够帮助企业找到最适合自己需求的技术人才，也能够帮助技术人才展示自己的专业技能和能力。作为全球领先的技术技能人才全产业链服务平台，我们希望为企业和个人提供一个高效、专业、全面的技能认证和评估服务平台。
        </div>
        <div class="btn-app" v-on:click="goDownload()">下载技能码APP</div>
      </div>
      <div v-show="showMask">
        <div class="mask"></div>
        <div class="notice">
          <img class="img" src="../assets/download-guide.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showMask: false,
      showShadowBg: false,
      showNormalBg: false,
    };
  },
  name: "AutoDownload",
  mounted() {
    if (!this.isWeiXin()) {
      this.goDownload();
    }
  },
  methods: {
    isWeiXin() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf("micromessenger") !== -1;
    },
    isIos() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf("iphone") > -1 || ua.indexOf("mac os") > -1;
    },
    goDownload() {
      console.log("是iOS");
      if (this.isWeiXin()) {
        this.showMask = true;
        this.showShadowBg = true;
        this.showNormalBg = false;
      } else if (this.isIos()) {
        this.showMask = false;
        this.showShadowBg = false;
        this.showNormalBg = true;
        // window.location.href = 'https://apps.apple.com/cn/app/id1566830507'

        const loadDateTime = new Date();
        window.location.href =
          "https://apps.apple.com/cn/app/%E6%8A%80%E8%83%BD%E7%A0%81/id6476258976"; //ios下载地址
        // todo 深度链接需要配一下
      } else {
        this.showMask = false;
        this.showShadowBg = false;
        this.showNormalBg = true;
        // todo 安卓逻辑

        window.location.href = "zjyopenapp://";
        // 这样如果你安装了app就可以成功唤醒app了
        // 这个延时就是在三秒没有反应跳到百度了，这里你可以写下载链接。或者引导用户下载。
        setTimeout(function () {
          let a = document.createElement("a");
          a.href = "https://genius-oss.markcode.com.cn/apk/geniusMark.apk";
          a.click();
        }, 3000);
      }
    },
  },
};
</script>

<style scoped>
.imageContainer img {
  position: relative;
  padding: 0;
  background-size: contain | cover;
  width: 100%;
  height: auto;
}
.logo{
   margin-top: 0.6rem;
}
.title {
  margin-top: 1rem;
  color: #333;
  font-weight: bold;
  font-size: 0.34rem;
  text-align: left;
  margin-right: 0.3rem;
  margin-left: 0.3rem;
  margin:0 auto;
  text-align:center;
  color: #0C68FF;
}

.btn-app {
  width: 3rem;
  color: #0C68FF;
  border-radius: 4px;
  border: 1px solid #0C68FF;
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.3rem;
  text-align: center;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}

.desc {
  margin-top: 1.2rem;
  color:  #7A8088;;
  font-size: 0.3rem;
  text-align: left;
  margin-right: 0.3rem;
  margin-left: 0.3rem;
  margin-bottom: 1.2rem;
  line-height: 0.52rem;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}

.notice {
  position: absolute;
  top: 0;
  right: 20px;
  width: 85%;
}

.notice img {
  position: relative;
  padding: 0;
  background-size: contain | cover;

  width: 100%;

  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/AutoDownload.vue